import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum QuizStep {
  NONE,
  CUSTOMER,
  MODEL,
  PURCHASE,
  VALUATION,
  ADDRESS,
  PAYMENT,
  COMPLETE,
}

interface QuizState {
  step: QuizStep
  prevStep: QuizStep
  customerId: string
  customerName: string
  customerEmail: string
  purchaseModel: string
  purchaseSerialFile: string
  purchaseReceiptFile: string
  purchaseSerial: string
  purchaseDate: string
  purchaseVendor: string
  tradeInManufacturer: string
  tradeInSerial: string
  tradeInWorking: boolean
  shippingAddressLine1: string
  shippingAddressCity: string
  shippingAddressPostcode: string
  shippingAddressCountry: string
  shippingAddressCountryCode: string
  paymentAccountHolder: string
  paymentIban: string
}

const initialState: QuizState = {
  step: QuizStep.CUSTOMER,
  prevStep: QuizStep.NONE,
  customerId: '',
  customerName: '',
  customerEmail: '',
  purchaseModel: '',
  purchaseReceiptFile: '',
  purchaseSerialFile: '',
  purchaseSerial: '',
  purchaseDate: '',
  purchaseVendor: '',
  tradeInManufacturer: '',
  tradeInSerial: '',
  tradeInWorking: false,
  shippingAddressLine1: '',
  shippingAddressCity: '',
  shippingAddressPostcode: '',
  shippingAddressCountry: '',
  shippingAddressCountryCode: '',
  paymentAccountHolder: '',
  paymentIban: '',
}

export const QuizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    updateQuiz: (state, action: PayloadAction<Partial<QuizState>>) => {
      Object.assign(state, action.payload)
    },
    clearQuiz: () => initialState,
  },
})

export const { updateQuiz, clearQuiz } = QuizSlice.actions

export default QuizSlice.reducer
